import React from 'react'

import SelectField, { SelectFieldProps } from './SelectField'
import TextField, { TextFieldProps } from './TextField'

export interface RequiredTextFieldProps extends Omit<TextFieldProps, 'rules'> {
  optionalRules?: Omit<TextFieldProps['rules'], 'required'>
}

export const RequiredTextField: React.FC<RequiredTextFieldProps> = ({
  optionalRules,
  ...other
}) => <TextField {...other} rules={{ ...optionalRules, required: true }} />

export interface RequiredSelectOption {
  label: string
  value: string
}

export interface RequiredSelectFieldProps extends Omit<SelectFieldProps, 'rules'> {
  optionalRules?: Omit<SelectFieldProps['rules'], 'required'>
}

export const RequiredSelectField: React.FC<RequiredSelectFieldProps> = ({
  optionalRules,
  ...other
}) => <SelectField {...other} rules={{ ...optionalRules, required: true }} />
